import { API } from "@/services"

export const CALLREPORTS_ENDPOINTS = {
  chart(params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `callreports/chart`,
      method: 'GET',
      params,
    })
  },
  callHangupChart(params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `callreports/call-hangup/chart`,
      method: 'GET',
      params,
    })
  },
  callHangupReportsList(params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `callreports/call-hangup`,
      method: 'GET',
      params,
    })
  },
  chartPassFail(params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `callreports/chart/call-pass-fail`,
      method: 'GET',
      params,
    })
  },
  checkFail(params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `callreports/check-fail`,
      method: 'GET',
      params,
    })
  },
}